/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getWonSalesTimeseries(params = {}) {
    return axios.get(`${this.url}/won_sales_timeseries`, { params });
  }

  getStageContacts(params = {}) {
    return axios.get(`${this.url}/stage_contacts`, { params });
  }

  getContactStageHistory(contactId) {
    return axios.get(`${this.url}/contact_stage_history`, {
      params: { contact_id: contactId },
    });
  }

  getGroupedConversations({ groupBy } = { groupBy: 'assignee_id' }) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy },
    });
  }
}

export default new LiveReportsAPI();
